<div class="d-flex gap-2">
    <p class="fw-bold fs-4">{{ "help.faqs.title" | translate }}</p>
</div>

<div class="bg-card shadow-md rounded p-2 mb-3">
    <form class="col-12" [formGroup]="faqsForm">
        <div class="bg-card shadow-md rounded p-2 mb-3">
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown
                        controlName="categoryId"
                        formControlName="categoryId"
                        [label]="'help.faqs-category.title' | translate"
                        [options]="categories()"
                        [invalid]="checkInvalid('categoryId')"
                        [setValidator]="formValidation()!"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.onlineHelpLinkAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('onlineHelpLinkAE')"
                        formControlName="onlineHelpLinkAE"
                        controlName="onlineHelpLinkAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.onlineHelpLinkEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('onlineHelpLinkEN')"
                        formControlName="onlineHelpLinkEN"
                        controlName="onlineHelpLinkEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.questionAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('questionAE')"
                        formControlName="questionAE"
                        controlName="questionAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.questionEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('questionEN')"
                        formControlName="questionEN"
                        controlName="questionEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.answerAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('answerAE')"
                        formControlName="answerAE"
                        controlName="answerAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.answerEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('answerEN')"
                        formControlName="answerEN"
                        controlName="answerEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.videoLinkAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('videoLinkAE')"
                        formControlName="videoLinkAE"
                        controlName="videoLinkAE"
                    ></adaa-form-input>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'help.faqs.videoLinkEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="checkInvalid('videoLinkEN')"
                        formControlName="videoLinkEN"
                        controlName="videoLinkEN"
                    ></adaa-form-input>
                </div>
            </div>
            <div class="row my-2">
                <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                    <adaa-form-input-file
                        [onDeleteRemoveFile]="false"
                        [allowedFileSize]="100024"
                        [allowedFiles]="allowedFiles"
                        [file]="getImage()"
                        (inputChanges)="onFileChange($event)"
                    ></adaa-form-input-file>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12 d-flex justify-content-center">
                    <adaa-form-checkbox
                        [label]="'help.faqs.published' | translate"
                        [checkboxMode]="'yesNo'"
                        controlName="published"
                        formControlName="published"
                    ></adaa-form-checkbox>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="my-2">
    <adaa-form-action-buttons
        [showSaveButton]="pageMode() !== PageMode.view"
        [saveButtonTitle]="'common.form.button.submit' | translate"
        [cancelButtonTitle]="pageMode() === PageMode.view ? ('common.form.button.close' | translate) : ('common.form.button.cancel' | translate)"
        (saveClicked)="submit()"
        (cancelClicked)="close()"
    ></adaa-form-action-buttons>
</div>
